export default __webpack_public_path__ + "static/applying-grid-dark-bc82b203f4deff9edaf64e2d71c1224c92ff39d82c762cc0894e3a32a02a37cf.png";